import { render, staticRenderFns } from "./ElementRow.vue?vue&type=template&id=7881c1ba&scoped=true&"
import script from "./ElementRow.vue?vue&type=script&lang=ts&"
export * from "./ElementRow.vue?vue&type=script&lang=ts&"
import style0 from "./ElementRow.vue?vue&type=style&index=0&id=7881c1ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7881c1ba",
  null
  
)

export default component.exports